import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";

@Component({
    selector: 'app-employee-app-tab-layout',
    templateUrl: './employee-app-tab-layout.component.html',
    styleUrls: ['./employee-app-tab-layout.component.scss'],
    standalone: false
})
export class EmployeeAppTabLayoutComponent implements OnInit {
  currentUser: any; 
  showSpinner: boolean = false;
  TabDisabled: boolean = false;
  EmployeeSummary: any = { EmployeeId:"0"};
  EmployeeId: any;
  currentEmployeeTab: number = 0;
  lastFillTab: number = 0;
  Add:any;
  constructor(
    private dataSharingService: DataSharingService,
    private _EncrDecrService: EncrDecrService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.EmployeeSummary.EmployeeId = this._EncrDecrService.decrypt(decodeURIComponent(param.get("Id")));
      this.Add = param.get("Add");
      console.log("currentEmployeeTab", this.currentEmployeeTab);
     
    });}

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    //this.dataSharingService.LOSHeaderTitle.next("Application Detail");
    if (this.Add == "true" && this.currentEmployeeTab == 0) {
      this.currentEmployeeTab = 1;
    
    }
  
    if (this.EmployeeSummary.EmployeeId !=0) {
      this.TabDisabled = false;
    } else {
      this.TabDisabled = true;
    }
   
  }

  onTabChange(event: any) {
    this.currentEmployeeTab = event.index;
  }

}
